import { mallApi } from '../request'
import { apiPath } from '../api'

export const stockout = {
  subscribeArriveNotice: data =>
    mallApi.post(apiPath.subscribeArriveNotice, data)
}
